import {typed} from '../../../typed';

import {ASTNodeArgument} from './class';

/**
 * ASTNodeArgumentNumber constructor.
 */
@typed.decorate('ASTNodeArgumentNumber')
export class ASTNodeArgumentNumber extends ASTNodeArgument {
	constructor() {
		super();
	}
}
